import React, { useState, useEffect } from 'react';
import {
  FileText,
  Plus,
  Edit,
  Download,
  RefreshCw
} from 'lucide-react';
import { useToast } from '../../common/Toast';
import API_CONFIG from '../../../config/api';
import PageBreadcrumb from '../../common/PageBreadcrumb';
import PageHeader from '../../common/PageHeader';

const CustomReports = () => {
  const { success, error: showError } = useToast();
  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState([]);

  useEffect(() => {
    loadReports();
  }, []);

  const loadReports = async () => {
    setLoading(true);
    try {
      // TODO: Implement API call when backend is ready
      setReports([]);
    } catch (err) {
      console.error('Error loading custom reports:', err);
      showError('Error loading custom reports.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageBreadcrumb />
      <PageHeader
        title="Custom Reports"
        description="Create and manage custom reports for specific business needs"
      />
      <div className="page-container">
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div className="spinner"></div>
            <p>Loading custom reports...</p>
          </div>
        ) : (
          <div style={{ padding: '20px' }}>
            <div className="grid-modern-3" style={{ marginBottom: '24px' }}>
              <div className="asset-landing-card">
                <div style={{ padding: '24px' }}>
                  <div className="d-flex align-items-center mb-3">
                    <FileText size={24} color="var(--gold-primary)" />
                    <h4 style={{ marginLeft: '12px', margin: 0 }}>Custom Reports</h4>
                  </div>
                  <p style={{ color: '#6b7280', margin: 0 }}>
                    Custom reports are coming soon. This section will allow you to create and manage custom reports for specific business needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CustomReports;